<template>
    <div>
        <div class="text-center text-muted d-flex flex-column justify-content-center align-items-center" :style="{minHeight: compact ? '120px' : '521px'}">
            <template v-if="error">
                <i class="bi bi-exclamation-triangle-fill text-danger" style="font-size: 2rem;"></i>
                <h6 class="mt-3 text-danger">{{error}}</h6>
                <b-button v-if="$listeners.retry" size="sm" variant="outline-secondary" class="mt-2" @click="$emit('retry')">다시 시도</b-button>
            </template>
            <template v-else-if="loading">
                <b-spinner></b-spinner>
                <h6 class="mt-3 gray-400">{{loadingText}}</h6>
            </template>
            <template v-else>
                <i class="bi bi-exclamation-circle-fill" style="font-size: 2rem;"></i>
                <h6 class="mt-3 gray-400">{{text}}</h6>
            </template>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PageEmptyComponent',
    props: {
        text: {
            type: String,
            default: ''
        },
        loading: {
            type: Boolean,
            default: false,
        },
        loadingText: {
            type: String,
            default: ''
        },
        // 비어 있지 않으면 loading/text 대신 오류 상태를 보여준다. @retry 리스너가 있으면 '다시 시도' 버튼 표시
        error: {
            type: String,
            default: ''
        },
        // 콘솔 섹션/모달처럼 작은 영역용
        compact: {
            type: Boolean,
            default: false
        }
    }
};
</script>
